<template>
  <CommonVCard>
    <h2 class="registration-form__header mb-4">
      {{ $t("player_registration.player_registration") }}
    </h2>
    <CommonPlayerProfileFormField
      :changeFormField="handleChangePlayer"
      :disabled="disabled"
      :fieldValue="playerRegistration"
      :items="players"
      :label="$t('player_registration.select_player')"
      :rules="{
        required: {
          value: 0
        }
      }"
      :type="RegistrationAnswerType.OPTIONS_CHOOSE_ONE"
      customClassName="mb-2"
      name="player"
    />
  </CommonVCard>
</template>

<script>
import CommonVCard from "./CommonVCard";
import CommonPlayerProfileFormField from "./CommonPlayerProfileFormField";
import { i18n } from "@/plugins/i18n";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { RegistrationAnswerType } from "../enums/AnswerType";
import PlayerRegistrationPlayerDetailsBase from "./PlayerRegistrationPlayerDetailsBase";

export default {
  name: "PlayerRegistrationFormPlayerCard",
  components: { CommonVCard, CommonPlayerProfileFormField },
  mixins: [PlayerRegistrationPlayerDetailsBase],
  props: {
    disabled: { type: Boolean, required: false }
  },
  data: () => ({
    players: [
      {
        name: `+ ${i18n.tc("player_registration.add_new_player")}`,
        value: "new_player"
      }
    ],
    RegistrationAnswerType
  }),

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerProfileForm",
      "playerRegistration",
      "playersToRegistration",
      "playerRegistrationDetails",
      "playerAvatar"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setPlayerProfileFormValues",
      "setPlayerRegistration",
      "setPlayerAvatar",
      "clearPlayerAvatar"
    ]),

    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "fetchPlayerRegistrationDetails",
      "clearPlayerRegistrationDetails"
    ]),

    async handleChangePlayer(e) {
      const { registrationId, orgUnitId } = this.$route.params;
      const playerParam = e !== "new_player" ? `/player/${e}` : "";
      if (orgUnitId) {
        this.$router.push(
          `/register/${registrationId}/org-unit/${orgUnitId}${playerParam}`
        );
      } else {
        this.$router.push(`/register/${registrationId}${playerParam}`);
      }
      const playerRegistration = {
        value: e,
        name: this.players.find(item => item.value === e)?.name
      };
      if (e !== this.playerRegistration.value) {
        this.setPlayerRegistration({ playerRegistration });
        if (e === "new_player") {
          this.setPlayerProfileFormValues({
            playerProfileForm: this.playerProfileForm.map(item => {
              return { ...item, value: "" };
            })
          });
          this.clearPlayerAvatar();
          this.clearPlayerRegistrationDetails();
        } else {
          await this.fetchPlayerRegistrationDetails({
            registrationId: this.$route.params.registrationId,
            playerId: e
          });
        }
      }
    }
  },

  watch: {
    playersToRegistration: function(newValue) {
      const mappedPlayers = newValue.map(
        ({ firstName, lastName, playerId, registered }) => {
          return {
            name: `${firstName} ${lastName}${
              registered
                ? ` - ${i18n.tc("player_registration.registered")}`
                : ""
            }`,
            value: playerId,
            disabled: registered
          };
        }
      );
      this.players = [...this.players, ...mappedPlayers];
    }
  }
};
</script>

<style scoped>
.registration-form__header {
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}
</style>
